export const PUSH_HUB_BASE_PATH = '/push-notifications';

export const PUSH_HUB_TABS = [
  { id: 'campaigns', label: 'Campaigns', path: PUSH_HUB_BASE_PATH },
  { id: 'templates', label: 'Templates', path: `${PUSH_HUB_BASE_PATH}/templates` },
  { id: 'recipients', label: 'Recipients', path: `${PUSH_HUB_BASE_PATH}/recipients` },
  { id: 'fcm-tokens', label: 'FCM Tokens', path: `${PUSH_HUB_BASE_PATH}/fcm-tokens` },
  { id: 'delivery', label: 'Delivery', path: `${PUSH_HUB_BASE_PATH}/delivery` },
  { id: 'analytics', label: 'Analytics', path: `${PUSH_HUB_BASE_PATH}/analytics` },
] as const;

export type PushHubTabId = (typeof PUSH_HUB_TABS)[number]['id'];

export type PushNotificationTemplate = {
  id: string;
  name: string;
  title: string;
  message: string;
  imageUrl: string | null;
  bannerImageUrl?: string | null;
  notificationType: string;
  intentType: string;
  intentValue: string | null;
  isActive: boolean;
  createdById?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type PushDeliveryLog = {
  id: string;
  executionId: string;
  campaignId: string;
  campaignTitle: string | null;
  templateId?: string | null;
  templateName?: string | null;
  notificationType: string | null;
  recipientType: string;
  recipientId: string | null;
  userId: string | null;
  vendorId: string | null;
  recipientName: string;
  recipientPhone: string | null;
  recipientEmail: string | null;
  deviceId: string | null;
  platform: string | null;
  status: string;
  displayStatus?: string;
  fcmErrorCode: string | null;
  skipReason: string | null;
  errorMessage?: string | null;
  sentAt: string | null;
  deliveredAt?: string | null;
  clickedAt?: string | null;
  readAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type PushDeliveryStatusCounts = {
  queued: number;
  sent: number;
  delivered?: number;
  read?: number;
  failed: number;
  skipped: number;
  total: number;
};

export type PushRecipientRow = {
  recipientKey: string;
  recipientType: string;
  userId: string | null;
  vendorId: string | null;
  name: string;
  phone: string | null;
  email: string | null;
  total: number;
  sent: number;
  failed: number;
  queued: number;
  skipped: number;
  lastAt: string | null;
  lastStatus: string | null;
  lastCampaignTitle: string | null;
  lastCampaignId: string | null;
};

export type PushPaged<T> = {
  items: T[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    limit: number;
  };
};

export type FcmOwnerType = 'USER' | 'VENDOR' | 'GUEST';

export type FcmTokenOwnerRow = {
  ownerType: FcmOwnerType;
  ownerId: string;
  name: string;
  phone: string | null;
  email?: string | null;
  vendorRole?: string | null;
  tokenCount: number;
  activeTokenCount: number;
  inactiveTokenCount: number;
  notifiable: boolean;
  notifiablePlatforms: string[];
  platforms: string[];
  lastUsedAt: string | null;
  firstRegisteredAt: string | null;
};

export type FcmTokenDeviceRow = {
  id: string;
  ownerType: FcmOwnerType;
  ownerId: string;
  deviceId: string;
  platform: string;
  isActive: boolean;
  formatOk: boolean;
  tokenPreview: string;
  lastUsedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  appVersionCode: number | null;
  validation?: { valid: boolean | null; code: string | null; message: string | null };
};

export type FcmTokenInsights = {
  totals: {
    tokenRows: number;
    activeTokens: number;
    inactiveTokens: number;
    guestTokens: number;
    userTokens: number;
    vendorTokens: number;
    notifiableUsers: number;
    notifiableVendors: number;
    notifiableGuests: number;
  };
  byOwnerType: Record<
    string,
    { active: number; inactive: number; notifiableOwners: number }
  >;
  byPlatform: { android: number; ios: number; web: number; unknown: number };
  notifiableRateHint?: string;
};
